// extracted by mini-css-extract-plugin
module.exports = {"header":"list_header__3R-T1","heading":"list_heading__2UIGg","url":"list_url__132Zk"};